module.exports = __webpack_public_path__ + "img/sound.ef540399.svg";